export const EMPLOYEE_DOCUMENTS_PAGE_SIZE = 11;
